class OrderInstructionsService {
    constructor($q, restangular, bootstrap, fulfilmentService) {
        this.api = restangular.one('Delivery');
        this.fulfilmentService = fulfilmentService;

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.DeliveryInfo)) {
            this.deliveryMessage = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).DeliveryInstruction;
            this.pickupMessage = bootstrap.getBootstrappedData(bootstrap.bootstrapped.DeliveryInfo).PickupInstruction;
        }
    }

    getSavedMessage() {
        return this.fulfilmentService.isDelivery()
            ? this.deliveryMessage
            : this.pickupMessage;
    }

    setInstructions(message) {
        return this.fulfilmentService.isDelivery()
            ? this.setDeliveryMessage(message)
            : this.setPickupMessage(message);
    }

    setDeliveryMessage(message) {
        return this.api.one('DeliveryMessage').doPOST({ DeliveryMessage: message })
            .then((response) => { this.deliveryMessage = response.SavedDeliveryMessage; });
    }

    setPickupMessage(message) {
        return this.api.one('PickupMessage').doPOST({ PickupMessage: message })
            .then((response) => { this.pickupMessage = response.SavedPickupMessage; });
    }
}

OrderInstructionsService.$inject = ['$q', 'Restangular', 'BootstrapService', 'FulfilmentService'];

module.exports = OrderInstructionsService;



// WEBPACK FOOTER //
// ./src/order/orderinstructions/order-instructions.service.js